export default {
    "dynamicFormsDelete_title": "Eliminar Formularios",
    "dynamicFormsDelete_deleteWarning": "¿Está seguro de que desea eliminar los siguientes formularios? Esta acción no se puede deshacer",
    "dynamicFormsDelete_success": "Exito",
    "dynamicFormsDelete_successMessage": "Formularios eliminados exitosamente",
    "dynamicFormsDelete_errorByWorkOrders": "No es posible eliminar los formularios que se utilizan en las órdenes de trabajo"
}